"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../namespaces");
const TypesCollection_1 = require("./Collections/TypesCollection");
const TemplatedResource_1 = require("./TemplatedResource");
const templatedLink = [namespaces_1.hydra.TemplatedLink];
const link = [namespaces_1.hydra.Link];
/**
 * Provides a default implementation of the {@link ITemplatedLink} interface.
 * @class
 */
class TemplatedLink extends TemplatedResource_1.default {
    /**
     * Initializes a new instance of the {@link TemplatedLink} class.
     * @param {ILink} linkResource Original link to create templated one from.
     * @param {IIriTemplate} template IRI template to take template from.
     */
    constructor(linkResource, template) {
        super(linkResource, template, linkResource.type
            .except(namespaces_1.hydra.Link)
            .toArray()
            .concat(templatedLink));
        this.relation = linkResource.relation;
        this.supportedOperations = linkResource.supportedOperations;
    }
    createInstance(resource) {
        const result = resource;
        result.relation = this.relation;
        result.supportedOperations = this.supportedOperations;
        result.type = new TypesCollection_1.default(this.type
            .except(namespaces_1.hydra.TemplatedLink)
            .toArray()
            .concat(link));
        return result;
    }
    getNextIri() {
        return `_:link${++TemplatedLink.id}`;
    }
}
exports.default = TemplatedLink;
TemplatedLink.id = 0;
//# sourceMappingURL=TemplatedLink.js.map